<template>
  <div id="order-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>销管审核</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary">发送</el-button>
        <el-button size="small" @click="reset()" type="primary">重置</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" id="orderCheck">
      <el-form :model="ruleForm" ref="form"
                label-position="right" label-width="100px" class="demo-ruleForm">
        <el-form-item label=" " >
            <el-button size="small" @click="add" type="primary">新增</el-button>
        </el-form-item>
        <div class="tabWarp" style="padding-left:100px;width:400px">
          <el-table  :data="ruleForm.list" border>
            <el-table-column
              prop="ruleForm.list.validNo"
              label="销售订单号"
              align="center"
              width="200">
              <template slot-scope="{column,row,$index}"><el-input  v-model="ruleForm.list[$index]"></el-input></template>
            </el-table-column>
            <el-table-column
              prop="date"
              label="操作"
              align="center"
              
              >
              <template slot-scope="{column,row,$index}"><el-button size="mini" @click="remove($index)" type="primary">删除</el-button></template>
            </el-table-column>
          </el-table>
        </div>
        <div class="tabWarp" >
          <label style="min-width:100px;">
            返回结果：
          </label>
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows:8}" v-model="ruleForm.remark">
          </el-input>
        </div>
      </el-form>
      
    </div>

  </div>

</template>
<script>
  import { mapGetters } from 'vuex';
  import { methodPost } from "../../api/request.js";
  export default {
    name: 'salesAudit',
    data() {
      return {
        ruleForm: {
          remark: '',
          list: ['']
        }
  
      }
    },
    methods: {
      reset() {
        this.ruleForm.orderDate = '';
        this.ruleForm.list = ['']
        this.ruleForm.remark = '';
      },
      save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        const URL = '/material/syncSaleCheck'
        const params = this.ruleForm.list
        methodPost(URL, params).then(res => {
          if (res.code === 0) {
            this.ruleForm.remark = res.data;
          } else {
            this.$message.error(res.message || '发送出错，请稍后再试')
          }
        })
      },
      // 添加
      add() {
        this.ruleForm.list.push('')
      },
      // 删除
      remove(index) {
        this.ruleForm.list.splice(index, 1)
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    }
  
  }
</script>
<style lang="scss" scoped>
 .sys-content{
   padding:20px;
 }
.tabWarp{
  padding:20px 0 0;
  display:flex;
  .el-input{
    width:178px!important;
    margin:5px 0!important;
  }
  label{
    color: #606266;
    font-size: 12px;
    text-align:right;
  }
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/orderCheck/salesAudit.vue